import { Navbar } from "@/components/landing/Navbar";
import { FinalCTA, Footer } from "@/components/landing/FooterCTA";
import { Breadcrumbs } from "@/components/Breadcrumbs";

export default function PageShell({ children, cta = true, crumbs }) {
  return (
    <div className="min-h-screen bg-[#eef1f7] flex flex-col">
      <Navbar />
      <div className="pt-16 sm:pt-20">
        {crumbs && crumbs.length > 0 && <Breadcrumbs items={crumbs} />}
      </div>
      <main className="flex-1">{children}</main>
      {cta && <FinalCTA />}
      <Footer />
    </div>
  );
}
